A monetary amount of remuneration in a specified currency.
